export const BASE_API_URL = process.env.REACT_APP_API_BASE_URL ? `${process.env.REACT_APP_API_BASE_URL}/api/v1` : 'http://localhost:8080/api/v1';

export const DASHBOARDADMIN = "dashboard.admin";
export const DASHBOARDREGIONADMIN = "dashboard.regionadmin";
export const DASHBOARDOPERATOR = 'dashboard.operator';
export const DASHBOARDEDITOR = 'dashboard.editor';
export const SUPERADMIN = "super.admin";

export const API_URLS = {
  AUTH: {
    LOGIN: `${BASE_API_URL}/auth/login`,
    CHANGE_PASSWORD: `${BASE_API_URL}/auth/change_password`,
    REFRESH_TOKEN: `${BASE_API_URL}/auth/refresh_token`,
  },
  USER: {
    GET_USER: `${BASE_API_URL}/user-mgmt/get/user`,
    GET_USER_ROLES: `${BASE_API_URL}/user-mgmt/get/user_roles`,
    GET_USER_COUNT: `${BASE_API_URL}/dashboard/user-mgmt/get_company_users_count`,
    GET_USER_LIST: `${BASE_API_URL}/dashboard/user-mgmt/get_users_with_scan_count`,
    GET_USER_DETAILS: `${BASE_API_URL}/dashboard/user-mgmt/get_user_scan_details`,
  },
  SCANS: {
    GET_SCAN_COUNT: `${BASE_API_URL}/dashboard/scan-mgmt/get_company_scan_count`,
    GET_SCAN_FILES: `${BASE_API_URL}/dashboard/scan-mgmt/get_scan_files`,
    GET_SCANS: `${BASE_API_URL}/dashboard/scan-mgmt/get_scan_data`,
    GET_SCAN_HISTORY: `${BASE_API_URL}/dashboard/scan-mgmt/get_scan_history`,
    GET_SCAN_PDF: `${BASE_API_URL}/dashboard/scan-mgmt/get_scan_pdf`,
    GET_MULTIPLE_SCAN_PDF: `${BASE_API_URL}/dashboard/scan-mgmt/get_multiple_scan_pdf`,
    GET_SCAN_CSV_DATA: `${BASE_API_URL}/dashboard/scan-mgmt/get_scan_csv_data`,
    GET_SCAN_CSV: `${BASE_API_URL}/dashboard/scan-mgmt/get_scan_csv`,
    UPDATE_SCAN_USER_METADATA: `${BASE_API_URL}/dashboard/scan-mgmt/update_scan_user_metadata`,
    GET_COMPANY_SCAN_FILES: `${BASE_API_URL}/dashboard/scan-mgmt/get_company_scan_files`,
    GET_SUB_SCANS: `${BASE_API_URL}/dashboard/scan-mgmt/get_sub_scans`,
    GET_SCAN_DETAILS: `${BASE_API_URL}/dashboard/scan-mgmt/get_scan_info`,
    UPDATE_SCAN_RESULTS: `${BASE_API_URL}/dashboard/scan-mgmt/update_scan_results`,
    GET_UPDATED_SCAN_PDF: `${BASE_API_URL}/dashboard/scan-mgmt/get_updated_scan_pdf`,
  },
  OPEN_SCAN_PDF: {
    GET_SCAN_PDF: `${BASE_API_URL}/dashboard/open-pdf-mgmt/get_scan_pdf`,
  },
  CROP_VARIETY_MACHINE: {
    GET_CROPS_AND_VARIETIES: `${BASE_API_URL}/dashboard/crop-variety-machine-mgmt/get_crops_by_id`,
    GET_MACHINES: `${BASE_API_URL}/dashboard/crop-variety-machine-mgmt/get_machines_by_id`,
  },
  METADATA: {
    GET_ALL_GLOBAL_METADATA: `${BASE_API_URL}/dashboard/metadata-mgmt/get/global_metadatas`,
    GET_METADATA_BY_COMPANY_ID: `${BASE_API_URL}/dashboard/metadata-mgmt/get_metadata_by_company_id`,
  },
  DEEP_ANALYSIS: {
    GET_ALL: `${BASE_API_URL}/dashboard/deep-analysis-mgmt/read_from_redis`,
    GET_ONE: `${BASE_API_URL}/dashboard/deep-analysis-mgmt/read_one`,
    UPDATE: `${BASE_API_URL}/dashboard/deep-analysis-mgmt/update_to_redis`,
  },
};


export const LocationCount = 24;